// Aspire injects VITE_API_URL in both local dev and Docker.
// In Docker, docker-entrypoint.sh writes a runtime override to window.__ENV__
// so the same image works across environments.
export const API_BASE_URL =
  window.__ENV__?.VITE_API_URL || import.meta.env.VITE_API_URL || "";
